import { render, staticRenderFns } from "./Notificacao.vue?vue&type=template&id=1a3b7ed4&scoped=true"
import script from "./Notificacao.vue?vue&type=script&lang=js"
export * from "./Notificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3b7ed4",
  null
  
)

export default component.exports